import { RaffleMetaData } from '../lib/types';
import { TESTING } from './misc';

const testWhitelist = new Map<string, RaffleMetaData>([
 
  [
    '55citBdiHAPHdr2odnm677YYVkaQCjhte6k1rCBPx2UH',
    { name: 'Saigo Monkey #1057' },
  ],
      [
    'GM1ZqzGeuzrA2TNyefREkFXSYC37mzCHmpKbWwU8YE4V',
    {
      name: 'Okay Cub #5011',
      overviewImageUri: '/resources/oc.png',
    },
  ],
        [
    'JDn3b5u31X3R46AJ7zcBRXz48bpYTrDDJRLpAQTzDF8u',
    {
      name: 'Ghost Kid #116',
      overviewImageUri: '/resources/gk1.png',
    },
  ],
    
    [
    'FXApNiqCTd47J2kmDK3re7XwdHYYc4P9HoZLTgtX7vje',
    {
      name: 'Saigo Monkey #299',
      overviewImageUri: '/resources/sm2.png',
    },
  ]
]);

const prodWhitelist = new Map<string, RaffleMetaData>([
  [
    'Gx6xTzj97pgk8Ze5sX1n47zbau2ZT1yznPiKL5dYu7v9',
    {
      name: 'Saigo Monkey #350',
      overviewImageUri: '/resources/sm1.png',
    },
  ],
    [
    'D1A94QgwA7AqvHrZHL1aEPwzKW6gdPrSGQ23j9Y9EoPx',
    {
      name: 'Primate #9768',
      overviewImageUri: '/resources/9767.png',
    },
  ],
    [
    '12vAyrFD3LvB4HQ1RasNJh9MdWrpQXLNqMBDLyp3AGtj',
    {
      name: 'Skellies #1175',
      overviewImageUri: '/resources/197.png',
    },
  ],
    [
    '8BWQYz29hPCpQffFHUdwBUET6PfxmtqPMiDWQG2jhbV2',
    {
      name: 'DUST protocol 50-50 raffle',
      overviewImageUri: '/resources/dust.png',
    },
  ],
    [
    '8BF28JfmyEX6zt45wajf833Zgk43eM9qztLTcoaxsFp8',
    {
      name: 'Skelly #1003',
      overviewImageUri: '/resources/7.png',
    },
  ]
]);

export const RAFFLES_WHITELIST = TESTING
  ? testWhitelist
  : prodWhitelist;
